// @flow
/**
 * Kabaddi Team Selection Logic
 * Defender ->
 *        Min : 2
 *        Max : 4
 * Raider ->
 *        Min : 1
 *        Max : 3
 * AllRounders ->
 *        Min : 1
 *        Max : 2
 * and maximum 7 players from the one team
 */
import '../../cricket/create_team/index_web.css';
import React from 'react';
import {
  EmptyData,
  ErrorMessage,
  HeaderWithTimer,
  PlaceHolder,
  RouteWrapper,
  ScreenBackground,
  View
} from '../../../component';
import { useLink } from 'react-router-stack';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { showErrorToast } from '../../../actions/app-actions-types';
import I18n from '../../../utilities/locale';
import useGame from '../../../utilities/hooks/game';
import CreateTeamBottomContainer from '../../component/create_team_bottom_container';
import CreateTeamHeaderKabaddi from '../../component/create_team_header_kabaddi';
import SwipeableViews from 'react-swipeable-views';
import CreateTeamTabBar from '../../component/create_team_tab_bar';
import CreateTeamTabContentKabaddi from '../../component/create_team_tab_content_kabaddi';
import { getRouteObjByGame, maskUserName } from '../../../utilities/helper';
import Constants from '../../../constants';

const CreateTeam = () => {
  const {
    item: matchItem = {},
    fantasyMatchClick,
    getPlayerList,
    firstName = '',
    lastName = '',
    teamName = '',
    gameType
  } = useGame();
  const navigate = useLink();
  const dispatch = useDispatch();

  const [sortName, setSortName] = useState('CREDITS');
  const [sortType, setSortType] = useState('UP');
  const [activeTab, setActiveTab] = useState(0);
  const [defenderList, setDefenderList] = useState([] as any);
  const [allRounderList, setAllRounderList] = useState([] as any);
  const [raiderList, setRaiderList] = useState([] as any);

  const [selectedDefender, setSelectedDefender] = useState(0);
  const [selectedRaider, setSelectedRaider] = useState(0);
  const [selectedAllRounder, setSelectedAllRounder] = useState(0);

  const [defenderListDisable, setDefenderListDisable] = useState(false);
  const [allRounderListDisable, setAllRounderListDisable] = useState(false);
  const [raiderListDisable, setRaiderListDisable] = useState(false);

  const [teamAPlayersCount, setTeamAPlayersCount] = useState(0);
  const [teamBPlayersCount, setTeamBPlayersCount] = useState(0);

  const [totalCreditCount, setTotalCreditCount] = useState(100);
  const [resultArrived, setResultArrived] = useState(false);
  const [error, setError] = useState(false);
  const [lineupsOut, setLineupsOut] = useState(false);

  const [routes] = useState([
    { key: 'DEF', title: 'DEF', totalSelectedPlayer: [1, 2, 3, 4] },
    { key: 'ALL', title: 'ALL', totalSelectedPlayer: [1, 2] },
    { key: 'RAI', title: 'RAI', totalSelectedPlayer: [1, 2, 3] }
  ]);

  const {
    _id: matchId,
    teamA = {},
    teamB = {},
    isEdit = false,
    isClone = false,
    entryFee,
    contestId,
    category,
    joinedMatch,
    bonusPercentage,
    matchTeamId = '',
    isTeamSwitch = false,
    isFromCreateTeamButton = false,
    selectedTeamPlayers = [],
    teamData = {},
    isFromMyTeam = false
  } = matchItem;

  const teamNumber = teamData?.teamNumber || 1;

  const onPressContinue = () => {
    const players = [...defenderList, ...allRounderList, ...raiderList];
    const myTotalSelectedPlayers = [] as any;
    players.forEach((item) => {
      if (item.isSelected === 'true') {
        myTotalSelectedPlayers.push(item);
      }
    });

    if (teamAPlayersCount + teamBPlayersCount === 7) {
      if (selectedDefender < 2) {
        dispatch(showErrorToast(I18n.t('selectMinDefenderKabaddi')));
      } else if (selectedDefender > 4) {
        dispatch(showErrorToast(I18n.t('selectMaxDefenderKabaddi')));
      } else if (selectedRaider < 1) {
        dispatch(showErrorToast(I18n.t('selectMinRaiderKabaddi')));
      } else if (selectedRaider > 3) {
        dispatch(showErrorToast(I18n.t('selectMaxRaiderKabaddi')));
      } else if (selectedAllRounder < 1) {
        dispatch(showErrorToast(I18n.t('selectMinAllRounderKabaddi')));
      } else if (selectedAllRounder > 2) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaximumAllRounder')));
      } else if (teamAPlayersCount > 5 || teamBPlayersCount > 5) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaxPlayersFromOneTeamKabaddi')));
      } else {
        let playerList: { id: any; playerId: any }[] = [];
        myTotalSelectedPlayers.forEach((item: { id: any; playerId: any }) => {
          playerList.push({
            id: item.playerId,
            playerId: item.id
          });
        });
        navigate.push(getRouteObjByGame(Constants.GameType.FANTASY_KABADDI)['choose_captain'], {
          item: matchItem,
          player: myTotalSelectedPlayers,
          matchId,
          isEdit,
          teamNumber,
          isClone,
          teamData,
          contestId,
          entryFee,
          category,
          joinedMatch,
          bonusPercentage,
          matchTeamId,
          isTeamSwitch,
          isFromCreateTeamButton,
          isFromMyTeam
        });
      }
    } else {
      dispatch(showErrorToast(I18n.t('MaxPlayersFromATeamKabaddi')));
    }
  };

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    let teamAPlayerCount = 0;
    let teamBPlayerCount = 0;
    let totalCredit = 100;
    let defenderCount = 0;
    let raiderCount = 0;
    let allRounderCount = 0;
    const data = {
      matchId
    };
    dispatch(
      getPlayerList({
        data,
        callback: ({ result = [], error }: { result: any; error: any }) => {
          setResultArrived(true);
          if (!error && result) {
            let data = [],
              allRounder: any = [],
              raider: any = [],
              defender: any = [];
            ///this is for calculate line up out
            let playingPlayersList = [];
            playingPlayersList = result.filter((player: any) => player.playingSeven === true);

            if (isEdit || isClone) {
              for (let i = 0; i < selectedTeamPlayers.length; i++) {
                for (let j = 0; j < result.length; j++) {
                  if (selectedTeamPlayers[i].playerId === result[j].id) {
                    result[j].isSelected = 'true';
                    if (result[j].role === 'defender' || result[j].role === 'wk') {
                      defenderCount++;
                    }
                    if (result[j].role === 'raider' || result[j].role === 'bowl') {
                      raiderCount++;
                    }
                    if (result[j].role === 'allrounder' || result[j].role === 'all') {
                      allRounderCount++;
                    }

                    if (result[j]?.teamId === teamA?.teamId) {
                      teamAPlayerCount++;
                      totalCredit = totalCredit - result[j].rating;
                    }
                    if (result[j]?.teamId === teamB?.teamId) {
                      teamBPlayerCount++;
                      totalCredit = totalCredit - result[j].rating;
                    }
                  }
                }
                data = result;
              }
            } else {
              data = result;
            }

            data.map((item: { isSelected: string; role: string; rating: string }) => {
              let isSelected = item.isSelected === 'true' ? 'true' : 'false';
              if (item.role === 'defender' || item.role === 'wk')
                defender.push({
                  ...item,
                  role: 'defender',
                  isSelected,
                  rating: parseFloat(item.rating)
                });
              else if (item.role === 'raider' || item.role === 'bowl')
                raider.push({
                  ...item,
                  role: 'raider',
                  isSelected,
                  rating: parseFloat(item.rating)
                });
              else if (item.role === 'allrounder' || item.role === 'all')
                allRounder.push({
                  ...item,
                  role: 'allrounder',
                  isSelected,
                  rating: parseFloat(item.rating)
                });
            });

            const allRounderList = allRounder.sort(
              (a: { rating: number }, b: { rating: number }) => b.rating - a.rating
            );
            const raiderList = raider.sort(
              (a: { rating: number }, b: { rating: number }) => b.rating - a.rating
            );
            const defenderList = defender.sort(
              (a: { rating: number }, b: { rating: number }) => b.rating - a.rating
            );

            setAllRounderList(allRounderList);
            setRaiderList(raiderList);
            setDefenderList(defenderList);

            setTeamAPlayersCount(teamAPlayerCount);
            setTeamBPlayersCount(teamBPlayerCount);
            setTotalCreditCount(totalCredit);
            setSelectedDefender(defenderCount);
            setSelectedRaider(raiderCount);
            setSelectedAllRounder(allRounderCount);
            setLineupsOut(playingPlayersList.length >= 7);
            setError(false);
          } else {
            setError(true);
          }
        }
      })
    );
  }

  const onPressPlayer = (item: any) => {
    const { role, isSelected } = item;

    let defenderCondition = false;
    let raiderCondition = false;
    let allRounderCondition = false;

    const actualCountDefender =
      selectedDefender + (role === 'defender' ? (isSelected === 'true' ? -1 : +1) : 0);

    const actualCountRaider =
      selectedRaider + (role === 'raider' ? (isSelected === 'true' ? -1 : +1) : 0);

    const actualCountAllRounder =
      selectedAllRounder + (role === 'allrounder' ? (isSelected === 'true' ? -1 : +1) : 0);

    const data =
      role === 'defender'
        ? [...defenderList]
        : role === 'allrounder'
        ? [...allRounderList]
        : [...raiderList];

    let teamAPlayerCount = teamAPlayersCount;
    let teamBPlayerCount = teamBPlayersCount;

    let minimumPlayer = 4;
    minimumPlayer =
      actualCountDefender >= 2 ? minimumPlayer - 2 : minimumPlayer - actualCountDefender;
    minimumPlayer = actualCountRaider >= 1 ? minimumPlayer - 1 : minimumPlayer;
    minimumPlayer = actualCountAllRounder >= 1 ? minimumPlayer - 1 : minimumPlayer;

    let teamACount = teamAPlayerCount;
    let teamBCount = teamBPlayerCount;
    let myTotalCredit = totalCreditCount;

    if (isSelected === 'false') {
      if (teamA?.teamId === item.teamId) {
        teamACount++;
        myTotalCredit = myTotalCredit - item.rating;
      }
      if (teamB?.teamId === item.teamId) {
        teamBCount++;
        myTotalCredit = myTotalCredit - item.rating;
      }
    } else {
      if (teamA?.teamId === item.teamId) {
        teamACount--;
        myTotalCredit = myTotalCredit + item.rating;
      }
      if (teamB?.teamId === item.teamId) {
        teamBCount--;
        myTotalCredit = myTotalCredit + item.rating;
      }
    }

    let totalPlayers = teamACount + teamBCount;
    let remainingPlayers = 7 - totalPlayers;

    let minimumDefender = actualCountDefender >= 2 ? 0 : 2 - actualCountDefender;
    let minimumRaider = actualCountRaider >= 1 ? 0 : 1;
    let minimumAllRounder = actualCountAllRounder >= 1 ? 0 : 1;

    if (
      ///to handle maximum defender
      role === 'defender' &&
      actualCountDefender >= 4
    ) {
      defenderCondition = true;
    }
    ///to handle minimum defender if there is only one player left
    else if (
      role != 'defender' &&
      actualCountDefender < 2 &&
      remainingPlayers <= 3 - actualCountDefender &&
      minimumPlayer <= 2
    ) {
      defenderCondition = true;
      allRounderCondition = true;
      defenderCondition = false;
    }
    //to handle other players
    else if (minimumDefender <= 0 && role === 'defender' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      defenderCondition = true;
      if (actualCountRaider >= 1 && minimumPlayer >= remainingPlayers) {
        // setRaiderListDisable(true)
        raiderCondition = true;
      }
      if (actualCountAllRounder >= 1 && minimumPlayer >= remainingPlayers) {
        // setAllRounderListDisable(true)
        allRounderCondition = true;
      }
    }
    if (
      ///to handle maximum raider
      role === 'raider' &&
      actualCountRaider >= 3
    ) {
      raiderCondition = true;
    }
    ///to handle minimum raider
    else if (
      role != 'raider' &&
      actualCountRaider < 1 &&
      remainingPlayers <= 1 &&
      minimumPlayer <= 1
    ) {
      defenderCondition = true;
      raiderCondition = false;
      allRounderCondition = true;
    }
    //to handle other players
    else if (minimumRaider <= 0 && role === 'raider' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      raiderCondition = true;
      if (actualCountDefender >= 2 && minimumPlayer >= remainingPlayers) {
        defenderCondition = true;
      }
      if (actualCountAllRounder >= 1 && minimumPlayer >= remainingPlayers) {
        allRounderCondition = true;
      }
    }
    if (
      ///to handle maximum all rounder
      role === 'allrounder' &&
      actualCountAllRounder >= 2
    ) {
      allRounderCondition = true;
    }
    ///to handle minimum allRounder
    else if (
      role != 'allrounder' &&
      actualCountAllRounder < 1 &&
      remainingPlayers <= 1 &&
      minimumPlayer <= 1
    ) {
      defenderCondition = true;
      raiderCondition = true;
      allRounderCondition = false;
    }
    //to handle other players
    else if (minimumAllRounder <= 0 && role === 'allrounder' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      allRounderCondition = true;
      if (actualCountDefender >= 1 && minimumPlayer >= remainingPlayers) {
        defenderCondition = true;
      }
      if (actualCountRaider >= 1 && minimumPlayer >= remainingPlayers) {
        raiderCondition = true;
      }
    }

    if (isSelected === 'false') {
      item.isSelected = 'true';
    } else {
      item.isSelected = 'false';
    }

    if ((minimumDefender <= 0 && minimumPlayer >= remainingPlayers) || actualCountDefender >= 4) {
      defenderCondition = true;
    }
    if ((minimumRaider <= 0 && minimumPlayer >= remainingPlayers) || actualCountRaider >= 3) {
      raiderCondition = true;
    }

    if (
      (minimumAllRounder <= 0 && minimumPlayer >= remainingPlayers) ||
      actualCountAllRounder >= 2
    ) {
      allRounderCondition = true;
    }

    if (role === 'defender') {
      setDefenderList(data);
    } else if (role === 'allrounder') {
      setAllRounderList(data);
    } else if (role === 'raider') {
      setRaiderList(data);
    }

    setDefenderListDisable(defenderCondition);
    setRaiderListDisable(raiderCondition);
    setAllRounderListDisable(allRounderCondition);
    setTeamAPlayersCount(teamACount);
    setTeamBPlayersCount(teamBCount);
    setTotalCreditCount(myTotalCredit);

    setSelectPlayer(role);
  };

  const setSelectPlayer = (role: any) => {
    let count = 0;
    const data =
      role === 'defender'
        ? [...defenderList]
        : role === 'allrounder'
        ? [...allRounderList]
        : [...raiderList];
    data.map((i) => {
      if (i.isSelected === 'true') {
        count++;
      }
    });
    if (role === 'defender') setSelectedDefender(count);
    else if (role === 'allrounder') setSelectedAllRounder(count);
    else if (role === 'raider') setSelectedRaider(count);
  };

  const onPressRetry = () => {
    setResultArrived(false);
    getData();
  };

  const renderWhenEmpty = () => {
    if (!resultArrived) return <PlaceHolder.Loader loadingMessage={''} />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return <EmptyData message={I18n.t('NoPlayerFound')} />;
  };

  const onPressBack = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: isFromMyTeam ? joinedMatch : false,
          contestId: isFromMyTeam ? contestId : '',
          entryFee: isFromMyTeam ? entryFee : '',
          isTeamSwitch: false,
          myContestJoinedTeams: [],
          contestType: {},
          isFromCreateTeamButton: false
        }
      })
    );
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
    return true;
  };

  const onPressTeamPreview = () => {
    const players = [...defenderList, ...allRounderList, ...raiderList];
    const selectedPlayers: any[] = [];
    players.map((item) => {
      if (item.isSelected === 'true') {
        selectedPlayers.push({
          ...item
        });
      }
    });
    if (selectedPlayers.length > 0) {
      const myTeamData = {
        ...teamData,
        players: selectedPlayers
      };
      let playerList: { id: any; playerId: any }[] = [];
      selectedPlayers.forEach((item: { id: any; playerId: any }) => {
        playerList.push({
          id: item.playerId,
          playerId: item.id
        });
      });
      navigate.push(getRouteObjByGame(Constants.GameType.FANTASY_KABADDI)['team_preview'], {
        matchAllPlayersList: players,
        teamData: myTeamData,
        matchId,
        item: matchItem,
        fromCreateTeam: true,
        lineupsOut,
        teamNumber
      });
    } else {
      dispatch(showErrorToast(I18n.t('PleaseSelectAtLeastOnePlayerToSeePreview')));
    }
  };

  const onPressPlayerMinus = () => {
    let playerObj = null;
    if (selectedRaider > 0) {
      playerObj = raiderList.find((item: { isSelected: string }) => item.isSelected === 'true');
    } else if (selectedAllRounder > 0) {
      playerObj = allRounderList.find((item: { isSelected: string }) => item.isSelected === 'true');
    } else if (selectedDefender > 0) {
      playerObj = defenderList.find((item: { isSelected: string }) => item.isSelected === 'true');
    }
    if (playerObj) onPressPlayer(playerObj);
  };

  const counts = {
    DEF: selectedDefender,
    RAI: selectedRaider,
    ALL: selectedAllRounder
  };

  const onChangeTabIndex = (index = 0) => {
    setActiveTab(index);
  };

  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onUpdateSortingList = ({
    defenderList,
    allRounderList,
    raiderList,
    sortName,
    sortType
  }: any) => {
    const defenderList_ = [...defenderList];
    setDefenderList(defenderList_);
    const allRounderList_ = [...allRounderList];
    setAllRounderList(allRounderList_);
    const raiderList_ = [...raiderList];
    setRaiderList(raiderList_);
    setSortName(sortName);
    setSortType(sortType);
  };

  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };

  const userName = `${maskUserName(firstName, lastName, teamName)} (T${teamNumber})`;

  return (
    <RouteWrapper>
      <ScreenBackground>
        <HeaderWithTimer
          onlyTimer={true}
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          teamName={userName}
          gameType={gameType}
        />
        <CreateTeamHeaderKabaddi
          counts={counts}
          teamACount={teamAPlayersCount}
          teamBCount={teamBPlayersCount}
          totalCreditCount={totalCreditCount}
          teamAName={teamA?.shortName}
          teamBName={teamB?.shortName}
          onPressPlayerMinus={onPressPlayerMinus}
        />
        <View className={'create-team-container'}>
          <CreateTeamTabBar
            onChangeTab={onChangeTab}
            activeTab={activeTab}
            counts={counts}
            routes={routes}
          />
          <SwipeableViews
            className={'create-team-swipeable-view'}
            index={activeTab}
            onChangeIndex={onChangeTabIndex}>
            <View className="create-team-tab">
              <CreateTeamTabContentKabaddi
                data={defenderList}
                matchItem={matchItem}
                onPressPlayer={onPressPlayer}
                selectedTab={activeTab}
                renderWhenEmpty={renderWhenEmpty}
                defenderList={defenderList}
                allRounderList={allRounderList}
                raiderList={raiderList}
                lineupsOut={lineupsOut}
                defenderListDisable={defenderListDisable}
                allRounderListDisable={allRounderListDisable}
                raiderListDisable={raiderListDisable}
                teamAPlayersCount={teamAPlayersCount}
                teamBPlayersCount={teamBPlayersCount}
                totalCreditCount={totalCreditCount}
                onUpdateSortingList={onUpdateSortingList}
                sortName={sortName}
                sortType={sortType}
              />
            </View>
            <View className="create-team-tab">
              <CreateTeamTabContentKabaddi
                data={allRounderList}
                matchItem={matchItem}
                onPressPlayer={onPressPlayer}
                selectedTab={activeTab}
                renderWhenEmpty={renderWhenEmpty}
                defenderList={defenderList}
                allRounderList={allRounderList}
                raiderList={raiderList}
                lineupsOut={lineupsOut}
                defenderListDisable={defenderListDisable}
                allRounderListDisable={allRounderListDisable}
                raiderListDisable={raiderListDisable}
                teamAPlayersCount={teamAPlayersCount}
                teamBPlayersCount={teamBPlayersCount}
                totalCreditCount={totalCreditCount}
                onUpdateSortingList={onUpdateSortingList}
                sortName={sortName}
                sortType={sortType}
              />
            </View>
            <View className="create-team-tab">
              <CreateTeamTabContentKabaddi
                data={raiderList}
                matchItem={matchItem}
                onPressPlayer={onPressPlayer}
                selectedTab={activeTab}
                renderWhenEmpty={renderWhenEmpty}
                defenderList={defenderList}
                allRounderList={allRounderList}
                raiderList={raiderList}
                lineupsOut={lineupsOut}
                defenderListDisable={defenderListDisable}
                allRounderListDisable={allRounderListDisable}
                raiderListDisable={raiderListDisable}
                teamAPlayersCount={teamAPlayersCount}
                teamBPlayersCount={teamBPlayersCount}
                totalCreditCount={totalCreditCount}
                onUpdateSortingList={onUpdateSortingList}
                sortName={sortName}
                sortType={sortType}
              />
            </View>
          </SwipeableViews>
          <CreateTeamBottomContainer
            onPressTeamPreview={onPressTeamPreview}
            onPressContinue={onPressContinue}
          />
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default CreateTeam;
